export var pickValidValues = option => Object.keys(option).reduce((acc, key) => {
  var _acc = acc;

  if (option[key] !== undefined) {
    _acc[key] = option[key];
  }

  return _acc;
}, {});